export const calculateDateProgressPercentage = (currentDate, startYear, endYear) => {
    const startMs = new Date(`${startYear}-01-01`).getTime()
    const endMs = new Date(`${endYear}-01-01`).getTime()
    const currentMs = new Date(currentDate).getTime()
    const durationMs = endMs - startMs

    if (durationMs <= 0) {
        return currentMs >= endMs ? 100 : 0
    }
    const elapsedMs = currentMs - startMs
    const percentage = (elapsedMs / durationMs) * 100
    return Math.min(100, Math.max(0, percentage))
}

export const getDateFromCursorX = (cursorX, elementLeft, elementWidth, startYear, endYear) => {
    const x = cursorX - elementLeft
    const percentage = Math.min(Math.max(0, x / elementWidth), 1)
    const totalYears = endYear - startYear
    const currentYearFloat = startYear + percentage * totalYears
    const dayOfYear = (currentYearFloat % 1) * 365
    return new Date(Math.floor(currentYearFloat), 0, 1 + Math.round(dayOfYear))
}

export const percentToPx = (percentage, totalPx) => (percentage / 100) * totalPx
